<template>
  <div :class="['form-container']">
    <div :class="['badge', 'img', 'img-' + element.img ]"></div>
    <div :class="['form-tile', answered ? 'form-tile-long': '']">
      <div class="title">{{element.title}}</div>
      <transition-group
        name="custom-classes-transition"
        enter-active-class="animated fadeInRight  "
        leave-active-class="animated fadeOutLeft  "
        mode="out-in"
      >
        <div class="question-container" :key="123" v-show="!answered">
          <template v-for="(questionObj, index) in this.shuffledQuestions">
            <div :key="index" :class="['question']" @click="select(index, questionObj)">
              <div class="radio-container">
                <div :class="['radio', selectedIndex === index ? 'selected': '']"></div>
              </div>
              <div class="question-text">{{questionObj.question}}</div>
            </div>
          </template>
        </div>
        <div class="answer-container" :key="12345" v-show="answered">
          <div
            :class="['status-text', answered ? 'long': '']"
          >{{correctAnswer ? 'Correct': 'Incorrect'}}</div>
          <div :class="['question']">
            <div class="radio-container">
              <div :class="['radio', correctAnswer ? 'correct': 'wrong']"></div>
            </div>
            <div class="question-text">{{element.questions[element.answer_index].question}}</div>
          </div>
        </div>
      </transition-group>
    </div>

    <transition-group
      name="custom-classes-transition"
      enter-active-class="animated fadeIn delay-500ms"
      leave-active-class="animated fadeOut delay-500ms"
      mode="out-in"
      class="back-button-container"
      v-show="answered"
    >
      <div
        :class="['back-btn', last ? 'small-button' : '']"
        v-show="answered"
        :key="1234"
        @click="back"
      >{{ last ? 'View Results' : 'Back to the Wheel'}}</div>
    </transition-group>
  </div>
</template>

<script>
// @ is an alias to /src
// import TileContent from "@/components/IntroTile/TileContent.vue";

export default {
  name: "form_element",
  props: { element: Object, last: Boolean },
  components: {},
  data() {
    return {
      pageIndex: 0,
      selectedIndex: -1,
      answered: false,
      correctAnswer: false
    };
  },
  computed: {
    shuffledQuestions: function() {
      return this.shuffle(this.element.questions);
    }
  },
  methods: {
    start() {},
    select(index, question) {
      if (this.answered) return;
      this.selectedIndex = index;
      setTimeout(() => {
        this.correctAnswer = question.answer;
        this.answered = true;
      }, 500);
    },
    shuffle(array) {
      return array.slice().sort(() => Math.random() - 0.5);
    },
    back() {
      if (this.last) this.$emit("results", this.correctAnswer);
      else this.$emit("back", this.correctAnswer);
    }
  },
  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="scss" scoped>
.form-container {
  width: 85%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 448px;
  min-height: 450px;
  left: 50%;
  transform: translateX(-50%);
  box-sizing: border-box;
  top: 0;
}

.form-tile {
  width: 100%;
  height: 60%;
  max-height: 280px;
  position: absolute;
  max-width: 448px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 0.4rem;
  box-shadow: 0 2px 6px #0000001a;
  overflow: hidden;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.badge {
  width: 100%;
  height: 115px;
  z-index: 10;
  position: absolute;
  top: 50%;
  transform: translateY(calc(-50% - 140px));
}

@media (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .badge {
    width: 100%;
    height: 115px;
    z-index: 10;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-198px);
  }

  .back-btn {
    margin: 0 !important;
  }

  .back-button-container {
    transform: translateY(95px);
  }
}

.title {
  font-family: "VW Head";
  font-weight: bold;
  width: 100%;
  text-align: center;
  margin-top: 70px;
  padding-left: 20px;
  padding-right: 20px;
}

.status-text {
  font-family: "VW Head";
  font-weight: 300;
  width: 100%;
  text-align: center;
  margin-top: 15px;
  margin-bottom: 15px;

  opacity: 0;
  transition: height, opacity 0.5s linear;
  height: 0px;
}

.long {
  height: 25px;
  overflow: hidden;
  opacity: 1;
}

.img {
  background-image: url("~@/assets/img/wheel_icon.svg?external");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.img-reg_brake {
  background-image: url("~@/assets/img/reg_brake.svg?external");
}
.img-wheels_on_corner {
  background-image: url("~@/assets/img/wheels_on_corner.svg?external");
}
.img-no_center_tunnel {
  background-image: url("~@/assets/img/no_center_tunnel.svg?external");
}
.img-high_voltage_battery {
  background-image: url("~@/assets/img/high_voltage_battery.svg?external");
}
.img-low_voltage_battery {
  background-image: url("~@/assets/img/low_voltage_battery.svg?external");
}
.img-seg_bat {
  background-image: url("~@/assets/img/seg_bat.svg?external");
}
.img-rear_wheel_drive {
  background-image: url("~@/assets/img/rear_wheel_drive.svg?external");
}
.img-compact_dashboard {
  background-image: url("~@/assets/img/compact_dashboard.svg?external");
}

.question-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 25px;
  position: absolute;
}

.question {
  width: 100%;
  text-align: left;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: row;
  margin-bottom: 10px;
  overflow: hidden;
}

.radio-container {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.radio {
  width: 20px;
  height: 20px;
  border: 1px solid #01b1ec;
  border-radius: 50%;
  box-sizing: border-box;
  // transition: border-colo 0.6s linear;
  cursor: pointer;
}

.radio:hover {
  border: 5px solid #01b1ec !important;
  transition: border-color, border-width 0.3s ease;
}

.correct {
  border: 5px solid #01b1ec !important;
  transition: border-color, border-width 0.3s ease;
}
.wrong {
  border: 5px solid #ff335c !important;
  transition: border-color, border-width 0.3s ease;
}

.selected {
  border: 5px solid #01b1ec;
}
.question-text {
  font-size: 0.7rem;
  width: 80%;
  font-family: "VW Text";
  font-weight: 300;
}

.back-button-container {
  width: 100%;
  height: 10%;
  position: relative;
  // bottom: 0;
  // left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(calc(-50% + 140px));
}

.back-btn {
  width: 80%;
  max-width: 235px;
  margin: 0 auto;
  height: 40px;
  background-color: rgba(0, 176, 240, 1);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: normal;
  cursor: pointer;
  font-family: "VW Text";
  font-weight: normal;
}

.small-btn {
  width: 80%;
  width: 60%;
  max-width: 160px;
  font-family: "VW Text";
  font-weight: normal;
}
.back-btn:hover {
  background-color: rgba(0, 176, 240, 0.8);
}

.back-btn:active {
  background-color: rgba(0, 176, 240, 0.5);
}

.question-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 25px;
  position: absolute;
}
</style>


<style lang="scss" scoped>
@media (max-width: 500px) {
  .form-tile {
    width: 100%;
    height: 70%;
    max-height: 325px;
  }
  .back-button-container {
    transform: translateY(calc(-50% + 160px));
  }
  .title {
    padding-left: 20px;
    padding-right: 20px;
  }

  .badge {
    width: 100%;
    height: 115px;
    z-index: 10;
    position: absolute;
    top: 50%;
    transform: translateY(calc(-50% - 165px));
  }
}
</style>